export const NotificationConfigsKey = 'notification-configs';
export const NotificationTemplatesKey = 'notification-templates';